// @flow
import React from 'react'
import withPage from 'server/withPage'
import gql from 'graphql-tag'
import { graphql } from 'react-apollo'
import SignUpPage from 'components/pages/SignUpPage'
import { bindActionCreators } from 'redux'
import queryString from 'query-string'
import { viewerFragment } from 'api/fragments'
import { authUrlWithQuery } from 'helpers/format'
import { checkTokenExpired } from 'helpers/auth'
import AccountUseCase, {
  type AccountUseCaseType,
  AccountUseCaseActionsBridge,
} from 'usecases/AccountUseCase'
import { amplitudeLogEvent } from 'helpers/amplitude'
import { imagePath } from 'frontend_core/dist/helpers/image'
import Path from 'routes/path'
import { wwwUrl } from 'frontend_core/dist/helpers/url'

type PropTypes = {
  accountUseCase: AccountUseCaseType,
  data: {
    viewer: {
      owners: {
        results: Array<{}>,
      },
    },
  },
  ui: {
    isLoading: boolean,
  },
  actions: {
    setUIState: Function,
  },
  config: {
    URL: string,
  },
}

class SignUpPageContainer extends React.Component<PropTypes> {
  componentDidMount() {
    const { accountUseCase, location } = this.props
    const queries = queryString.parse(location.search)

    // ソーシャルログイン経由のエラーを含む場合があるためここでチェックする
    accountUseCase.checkErrorMessage()

    if (queries.referred_by || queries.referredBy) {
      amplitudeLogEvent('Start Signup', { Referred: true })
    } else {
      amplitudeLogEvent('Start Signup', { Referred: false })
    }
  }

  componentWillUnmount() {
    const { accountUseCase } = this.props
    accountUseCase.clearAccount()
  }

  render() {
    const { data, ui, config, location } = this.props
    const referrerName = data?.referredUser?.name
    const isReferral = location.search.match(/referredBy/)
    const title = isReferral
      ? i18n.t('server.account.referralSignup.title')
      : i18n.t('server.account.signup.title')
    const description = isReferral
      ? i18n.t('server.account.referralSignup.description')
      : i18n.t('server.account.signup.description')
    const image = isReferral
      ? imagePath('service/common/referral-ogimage.png')
      : ''
    const authUrl = config.URL.includes('?')
      ? `${config.URL}&isSignUp=1`
      : `${config.URL}?isSignUp=1`
    return (
      <SignUpPage
        title={title}
        description={description}
        linkCanonical={wwwUrl(Path.signUp())}
        image={image}
        config={config}
        currentUser={data?.viewer}
        isLoading={ui.isLoading}
        googleAuthUrl={authUrlWithQuery(authUrl, 'google')}
        referrer={
          referrerName
            ? {
                name: referrerName,
              }
            : null
        }
      />
    )
  }
}

const pageQuery = gql`
query SignUpPage($referralToken: String) {
  viewer {
    ${viewerFragment}
  }
  referredUser: user(referralToken: $referralToken) {
    id
    name
  }
}`
const withData = graphql(pageQuery, {
  skip: checkTokenExpired(),
  options: props => {
    const { location } = props
    const queries = queryString.parse(location.search)
    const variables = {
      referralToken: queries.referred_by || queries.referredBy,
    }
    return { variables }
  },
})

function mapStateToProps(state) {
  return state
}
function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = Object.assign(AccountUseCaseActionsBridge)
  return { actions: bindActionCreators(bindActions, dispatch) }
}
export default withPage(
  AccountUseCase(SignUpPageContainer),
  mapStateToProps,
  mapDispatchToProps,
  {
    graphql: withData,
  },
)
